import React from "react";
import { CoachRecordInfo } from "./coach-recording-info/index";
import Modal from "src/components/modal/modal";

type ViewRecordButtonProps = {
  id: string;
  handleClose: () => void;
};

const ViewRecordModal = ({ id, handleClose }: ViewRecordButtonProps) => {
  return (
    <Modal onClose={handleClose} isOpen={true}>
      <CoachRecordInfo id={id} />
    </Modal>
  );
};

export default ViewRecordModal;
